// Los contratos del cliente son 1+N: `GET /credits/{creditId}/contracts` no acepta lote, y la
// pestaña Documentos pide dos filas por cada crédito, no solo por el vigente.
import { useQueries } from '@tanstack/react-query';
import { listCreditContracts } from '@/api/services/loan-credit';
import { readFailureOf } from '../lib/creditCustomersErrors';
import type { CreditContractsRead } from '../lib/customerDocuments';

const STALE_TIME_MS = 60_000;

/** Los contratos de cada crédito, indexados por `creditId`. Cada lectura falla por su cuenta. */
export function useCustomerCreditContracts(creditIds: string[]): Map<string, CreditContractsRead> {
    return useQueries({
        queries: creditIds.map((creditId) => ({
            queryKey: ['loan-credit', 'contracts', creditId] as const,
            queryFn: () => listCreditContracts(creditId),
            staleTime: STALE_TIME_MS,
            retry: false,
        })),
        // `combine` recorre las lecturas en el mismo orden en que se pidieron.
        combine: (results) =>
            new Map(
                results.map((query, index) => [
                    creditIds[index],
                    {
                        contracts: query.data,
                        isLoading: query.isPending,
                        failure: readFailureOf(query.error),
                    },
                ]),
            ),
    });
}
